import { useCallback, useState } from "react";
import moment from "moment";
import { MovimentacaoBancariaRequestParams } from "features/movimentacoes-bancarias/typings";

export const defaultFiltroMovimentacoesBancarias = {
  search: "",
  categoriasFinanceirasIds: [],
  contasBancariasIds: [],
  centrosDeCustoIds: [],
  categoriaIds: [],
  unidadeId: "",
  orderBy: "dataMovimentacao",
  orderDirection: "ASC",
  pessoaId: "",
  dataFim: moment().format("YYYY-MM-DD"),
  dataInicio: moment().startOf("month").format("YYYY-MM-DD"),
};

function useFiltroMovimentacoesBancarias() {
  const [filtro, setFiltro] = useState<MovimentacaoBancariaRequestParams>(
    defaultFiltroMovimentacoesBancarias
  );

  const onChangeFiltro = useCallback(
    (newValues: Partial<MovimentacaoBancariaRequestParams>) => {
      setFiltro((prev: any) => ({ ...prev, ...newValues }));
    },
    []
  );

  const onResetFiltro = useCallback(() => {
    setFiltro(defaultFiltroMovimentacoesBancarias);
  }, []);

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
    onResetFiltro,
  };
}

export default useFiltroMovimentacoesBancarias;
